import { appRoutes } from './app-routes';

export function safeReturnUrl(value: string | null): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u0020\u007f]/.test(value)) return null;
  try {
    const parsed = new URL(value, window.location.origin);
    if (parsed.origin !== window.location.origin) return null;
    let path = parsed.pathname;
    for (let attempt = 0; attempt < 3; attempt++) {
      const decoded = decodeURIComponent(path);
      if (decoded === path) break;
      path = decoded;
    }
    if (path.startsWith('//') || /[\\\u0000-\u0020\u007f]/.test(path)) return null;
    const callback = appRoutes.auth.callback().join('/');
    if (path === callback || path.startsWith(callback + '/')) return null;
    return parsed.pathname + parsed.search + parsed.hash;
  } catch {
    return null;
  }
}
